<!-- eslint-disable -->
<template lang="pug">
    .game-content
        .menu(v-if="currentPlayersAmount >= 1")
            multiplayer-menu(
                :slug="type",
                @commonParametersHasChanged="handleCommonParametersChange",
                @playersAmountChanged="handlePlayersAmountChange",
                :same-settings-are-active="sameSettingsAreActive",
                @changeGameState="handleGameStateChange",
                @refreshGame="invokeRefreshGameEvent",
                @checkAnswers="invokeCheckAnswersEvent",
                @continueGame="invokeContinueGameEvent",
                :check-answers-ready="isCheckAnswersReady",
                :players-ready-to-answer="arePlayersReadyToAnswer",
                :is-countdown="isCountdown"
            )
        games-wrapper(
            :type="type"
            :exercise-id="exerciseId"
            :homework-id="homeworkId"
            :players-number="currentPlayersAmount"
            :check-multiplayer-answers="checkMultiplayerAnswers"
            :play-again="playAgain"
            @playAgainReady="$event ? playAgainReadyScreens++ : playAgainReadyScreens--"
            @checkAnswersReady="handleCheckAnswersReadyEvent"
            :continue-game-event="continueGameEvent"
            :common-parameters-changer-counter="commonParametersChangerCounter"
            :multiplayer-games-state="multiplayerGamesState"
            :refresh-game-event="refreshGameEvent"
            @isCountdownActive="handleIsCountdownActive"
        )
</template>

<script>
    /*eslint-disable*/
    import PlayBox from './PlayBox.vue';
    import GamesWrapper from '../GamesWrapper.vue';
    import MultiplayerCommonMenuMixin from "../../../../utils/multiplayer/commonMenuMixin";

    export default {
        props: ['exerciseId', 'homeworkId', 'type', 'sameSettingsAreActive'],
        mixins: [MultiplayerCommonMenuMixin],
        data () {
            return {
                checkMultiplayerAnswers: false,
                playAgain: false,
                playAgainReadyScreens: 0,
                checkAnswersReadyScreens: 0,
                isCountdown: false
            }
        },
        methods: {
            sendPlayAgainEvent () {
                this.playAgain = true;
                this.$nextTick(() => {
                  this.playAgain = false;
                });
            },
            handleCurrentGameParametersChange (parameter) {
                let newParamsArray = this.paramsArray;
                newParamsArray.forEach(params => {
                    if (parameter.setCombiningValues) {
                        parameter.names.forEach((name, index) => {
                            params[name] = parameter.values[index];
                        });
                        return;
                    }
                    params[parameter.name] = parameter.value;
                    if (parameter.name === 'amountOfExamples' && parameter.value) {
                        params.timeLimit = 0;
                    }
                    if (parameter.name === 'difficult' && params.combining) {
                        // if multiplayer settings are not the same for everyone
                        // i set combining to default to avoid problems with numbers generation
                        // when difficulty is changed
                        params.combining = false;
                        params.combiningDigitCapacities = [];
                    }
                });
                this.$store.dispatch('setParamsArray', newParamsArray);
            },
            handleIsCountdownActive (isActive) {
                this.isCountdown = isActive;
            },
        },
        components: {
            PlayBox,
            GamesWrapper
        },
        beforeRouteLeave (to, from, next) {
            if (this.$store.state.trainer.game) {
                if (!(to.meta.type && to.meta.type === 'trainer')) {
                    this.$store.dispatch('setHomework', null);
                    this.$store.dispatch('setGame', null);
                }
            }
            next();
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/games/main.scss";
</style>
